import axiosApi from '../../axiosApi'

// initial state
const state = {
  individualUsers: []
}

// getters
const getters = {
  GET_INDIVIDUAL_USERS: (state) => {
    return state.individualUsers
  }
}

// actions
const actions = {
  getSearchIndividualUsers ({commit}, playload) {
    return axiosApi.post(`/get_individual_users`, playload
    ).then(response => {
      const { users } = response.data
      commit('SET_INDIVIDUAL_USERS', users)
      return users
    }).catch(e => {
      console.log(e)
    })
  }
}

// mutations
const mutations = {
  SET_INDIVIDUAL_USERS (state, playload) {
    state.individualUsers = playload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/friends.js